// constants
import { CategoryActionTypes } from "./constants";

export interface CategoryActionType {
  type:
    | CategoryActionTypes.API_RESPONSE_SUCCESS
    | CategoryActionTypes.API_RESPONSE_ERROR
    | CategoryActionTypes.UPDATE_CATEGORY
    | CategoryActionTypes.CREATE_CATEGORY
    | CategoryActionTypes.GET_CATEGORY
    | CategoryActionTypes.GET_CATEGORY_BY_ID
    | CategoryActionTypes.DELETE_CATEGORY;
  payload: {} | string;
}

interface categoryDetails {
  name: string;
  id: string;
}

// common success
export const categoryApiResponseSuccess = (
  actionType: string,
  data: categoryDetails | {}
): CategoryActionType => ({
  type: CategoryActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const categoryApiResponseError = (
  actionType: string,
  error: string
): CategoryActionType => ({
  type: CategoryActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createCategory = (
  name: string,
  isCamp: any
): CategoryActionType => ({
  type: CategoryActionTypes.CREATE_CATEGORY,
  payload: {
    name,
    isCamp,
  },
});

export const getCategory = (): CategoryActionType => ({
  type: CategoryActionTypes.GET_CATEGORY,
  payload: {},
});

export const deleteCategory = (id: string): CategoryActionType => ({
  type: CategoryActionTypes.DELETE_CATEGORY,
  payload: { id },
});
export const updateCategory = (
  id: string,
  name: string,
  isCamp: any
): CategoryActionType => ({
  type: CategoryActionTypes.UPDATE_CATEGORY,
  payload: { id, name, isCamp },
});

export const getCategoryById = (id: string): CategoryActionType => ({
  type: CategoryActionTypes.GET_CATEGORY_BY_ID,
  payload: { id },
});
